<template>
    <!-- 上课时段 -->
    <div>
        <div class="mb-15">
            <el-button type="primary" v-if="!isSelect" icon="el-icon-plus" @click="openAddTimeConfig('')">新增时段</el-button>
            <el-button type="primary" plain icon="el-icon-delete" @click="isSelect = true" v-if="!isSelect">批量删除</el-button>
            <el-button type="primary" v-if="isSelect" @click="openDeleteTimeconfig('')" :disabled="selection.length === 0">批量删除 ({{selection.length}})</el-button>
            <el-button type="primary" plain v-if="isSelect" @click="cancelDelete">取消批量删除</el-button>
        </div>
        <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" @selection-change="handleSelectionChange" :row-key="getRowKey" ref="table">
            <el-table-column type="selection" v-if="isSelect" fixed key="selection" class-name="selection" align="right" :width="getTableHeaderWidthByCheckCol(isSelect)"></el-table-column>
            <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                <template slot-scope="scope">
                    <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                </template>
            </el-table-column>
            <el-table-column prop="starttime" label="开始时间" align="center" key="starttime" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="endtime" label="结束时间" align="center" key="endtime" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="" label="操作" fixed="right" align="right" :width="getTableHeaderWidthByOpButton2()" key="edit" v-if="!isSelect">
                <template slot-scope="scope">
                    <div class="color-brand flex jc-sa ai-c">
                        <p class="pointer" @click="openAddTimeConfig(scope.row)">编辑</p>
                        <p class="pointer" @click="openDeleteTimeconfig(scope.row)">删除</p>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
        <AddTimeConfig ref="AddTimeConfig" @saveSuccess="saveSuccess"></AddTimeConfig>
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import {
  getTimeconfigList,
  deleteTimeconfig
} from '@/api/measApi/systemManage.js'
import AddTimeConfig from './components/addTimeConfig.vue'
export default {
  data() {
    return {
      total: 0,
      isSelect: false,
      tableData: [],
      contentLoading: false,
      params: {
        condition: {},
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      selection: []
    }
  },
  components: {
    TableSort,
    Page,
    AddTimeConfig
  },
  created() {
    this.getTimeconfigList()
  },
  methods: {
    //   获取日志列表
    getTimeconfigList() {
      this.contentLoading = true
      getTimeconfigList(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.contentLoading = false
          this.total = res.pageinfo.rowcount
        }
      })
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getTimeconfigList()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getTimeconfigList()
    },
    // 初始化表格
    formatTab(row, column, value) {
      return value ? value : '--'
    },
    // 多选
    getRowKey(row) {
      return row.code
    },
    // 选择
    handleSelectionChange(selection) {
      this.selection = selection
    },
    // 新增时段
    openAddTimeConfig(row) {
      this.$refs.AddTimeConfig.handleOpen(row)
    },
    saveSuccess() {
      this.params.page = 1
      this.getTimeconfigList()
    },
    // 取消批量删除
    cancelDelete() {
      this.isSelect = false
      this.$refs.table.clearSelection()
      this.selection = []
    },
    // 删除时段
    openDeleteTimeconfig(row) {
      this.$confirm(
        row ? '确认删除该时段吗？' : '确认删除选中的时段吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'measElMessage'
        }
      )
        .then(() => {
          let code = ''
          if (row) {
            code = row.code
          } else {
            let selectionCode = []
            this.selection.map(item => {
              selectionCode.push(item.code)
            })
            code = selectionCode.join(',')
          }
          deleteTimeconfig({ code: code }).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.params.page = 1
              this.getTimeconfigList()
              this.isSelect = false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

